import { useSectionContent } from "./useSectionContent";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, HeartHandshake, Activity, TreePine, MapPin, BookOpen, Sparkles, Users, ShieldCheck, Wind } from "lucide-react";
import api from "@/lib/api";
import CountUp from "@/components/motion/CountUp";
import { useSite } from "@/contexts/SiteContext";
import { useAuth } from "@/contexts/AuthContext";


/* Secțiuni noi de homepage (Dim 15). Fiecare e o secțiune CMS (visible din live editor). */


/* ── 15.23 „Copacul tău te așteaptă" — pentru utilizatorii logați care revin ── */
export function HomeWelcomeBack() {
  const c = useSectionContent("home_welcome_back");
  const { user } = useAuth();
  const [tree, setTree] = useState(null);
  useEffect(() => { if (user) api.get("/me/tree").then((r) => setTree(r.data)).catch(() => {}); }, [user]);
  if (!user || !tree) return null;
  const days = tree.last_present_date
    ? Math.floor((Date.now() - new Date(tree.last_present_date + "T12:00:00").getTime()) / 86400000) : null;
  return (
    <section className="py-8" style={{ background: "var(--ct-cream-edge)" }}>
      <div className="max-w-3xl mx-auto px-5 flex items-center justify-between gap-4 flex-wrap">
        <div>
          <p data-el="title" className="font-serif text-xl sm:text-2xl">
            Bine ai revenit, {user?.name?.split(" ")[0] || "drag"}. {tree.stage_name ? `Copacul tău — ${tree.stage_name} — te așteaptă.` : "Copacul tău te așteaptă."}
          </p>
          <p data-el="subtitle" className="text-xs mt-1" style={{ color: "var(--ct-text-muted)" }}>
            {days === 0 ? "Ai fost prezent(ă) azi. 🤍" : days === 1 ? "N-ai trecut pe aici de ieri — fără grabă." : days ? `N-ai trecut pe aici de ${days} zile — rădăcinile nu se pierd.` : "Fă primul check-in și plantează-ți copacul."}
          </p>
        </div>
        <Link data-el="cta" data-field="cta" to="/copacul-meu" className="btn-gold shrink-0" data-testid="welcome-back-cta">{c.cta || "La copacul meu"} <ArrowRight size={15} /></Link>
      </div>
    </section>
  );
}
